export default __webpack_public_path__ + "static/logo-281daa46a85dc0521a8280ddf2461851.png";